// TODO get these from frontend-components when it's Typescript
export enum Color {
    createBlue = '#5a94d2',
    risingSun = '#ce283D',
    forrestLyf = '#2f9780',
    squarespaceBlack = '#000000',
    puntRoad = '#555555',
    pacificBlue = '#1f3ca6',
}

export const MAX_TITLE_LENGTH = 100;
